import { ISecurity } from 'api/security.types'
import { combineReducers, Reducer } from 'redux'
import { IAccount } from '../../api/account.types'
import { IClient } from '../../api/client.types'
import { IHousehold } from '../../api/household.types'
import { IOrder } from '../../api/order.types'
import { IPosition } from '../../api/position.types'
import {
  reducer as securityReducer,
  sagas as securitySagas
} from '../../modules/Security/store'
import {
  reducer as accountListReducer,
  sagas as accountListSagas
} from './accounts/store'
import {
  reducer as clientListReducer,
  sagas as clientListSagas
} from './clients/store'
import { IListsState } from './core/store/reducers'

import {
  reducer as householdListReducer,
  sagas as householdListSagas
} from './households/store'
import {
  reducer as orderListRecuder,
  sagas as orderListSagas
} from './orders/store'
import {
  reducer as postionListReducer,
  sagas as postionListSagas
} from './positions/store'

export interface IListsFeatureState {
  account: IListsState<IAccount>
  client: IListsState<IClient>
  position: IListsState<IPosition>
  order: IListsState<IOrder>
  household: IListsState<IHousehold>
  security: IListsState<ISecurity>
}

export const reducer: Reducer<IListsFeatureState> = combineReducers({
  account: accountListReducer,
  client: clientListReducer,
  position: postionListReducer,
  order: orderListRecuder,
  household: householdListReducer,
  security: securityReducer
})

export const sagas = [
  ...accountListSagas,
  ...clientListSagas,
  ...postionListSagas,
  ...orderListSagas,
  ...householdListSagas,
  ...securitySagas
]
